"use client";

import {
  ForwardedRef,
  MouseEvent,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { useRouter } from "next/navigation";

export interface MyButtonProps {
  label: string;
  className?: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  type?: string;
  to?: string;
  disabled?: boolean;
  onMouseOver?: (e: MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: () => void;
  id?: string;
}

export interface MyButtonRef {
  setHover: () => void;
  setLeave: () => void;
}

const MyButton = forwardRef(function MyButtonComp(
  {
    label,
    className,
    onClick,
    type = "button",
    to,
    disabled,
    onMouseOver,
    onMouseLeave,
    id,
  }: MyButtonProps,
  ref: ForwardedRef<MyButtonRef>
) {
  const router = useRouter();
  const refButton = useRef<HTMLButtonElement>(null);

  useImperativeHandle(ref, () => ({
    setHover() {
      if (refButton.current) {
        refButton.current.classList.add(styles.hover_animation);
      }
    },
    setLeave() {
      if (refButton.current) {
        refButton.current.classList.remove(styles.hover_animation);
      }
    },
  }));

  const handleMouseLeave = () => {
    if (refButton.current) {
      refButton.current.classList.remove(styles.hover_animation);
    }
  };

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    onClick && onClick(e);
    to && router.push(to);
  };

  return (
    <button
      id={id}
      ref={refButton}
      disabled={disabled}
      type={type as any}
      onClick={handleClick}
      className={classNames(styles.button, className, {
        "!opacity-50": disabled,
      })}
      onMouseOut={(e) => {
        handleMouseLeave();
        onMouseLeave && onMouseLeave();
      }}
      onMouseEnter={onMouseOver}
    >
      <span className={styles.label_container}>
        <span className={styles.placeholder}>{label}</span>
        <span className={styles.black}>{label}</span>
        <span className={styles.orange}>{label}</span>
      </span>
    </button>
  );
});

export default MyButton;
